import React from 'react';
import { MetaTags } from 'react-meta-tags';
//import Breadcrumbs
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import 'react-drawer/lib/react-drawer.css';
import { Col, Container, Row } from 'reactstrap';
import { Toaster } from 'react-hot-toast';
import DriverAnalysisList from './components/DriverAnalysisList';
import DriverAnalysisExport from './components/DriverAnalysisExport';

const DriverAnalysis = () => {
  return (
    <React.Fragment>
      <div className="page-content refundOrder">
        <MetaTags>
          <title>Driver Analysis</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          {/* Title takes 3 columns rather than 4 - the export bar carries six
              controls and needs the extra width to stay on one line. */}
          <Row className="align-items-center">
            <Col xl={3}>
              <DashBreadcrumb
                title="Delivery"
                breadcrumbItem="Driver Analysis"
              />
            </Col>
            <Col xl={9}>
              <div className="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3">
                <DriverAnalysisExport />
              </div>
            </Col>
          </Row>
          <DriverAnalysisList />
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default DriverAnalysis;
